import { SbirYear } from './sbir-year.model';
import { SbirReceipt } from './sbir-receipt.model';

export class SbirCalculation {
  detectedFormType: string;
  years: SbirYear[];
  receipts: SbirReceipt[];

  constructor(taxCreditCalculation?: any) {
    if (taxCreditCalculation) {
      Object.assign(this, taxCreditCalculation);
    }
  }
}
